import React from 'react';

const WorkPermitStep8Review = ({ formData, permitTypes, machines }) => {
  const permitTypeName = permitTypes.find((p) => p.permitTypeId.toString() === formData.permitTypeId)?.typeName;
  const machineName = machines.find((m) => m.machineId.toString() === formData.equipmentId)?.machineName;

  return (
    <div className="work-permit-step reviewsubmit">
      <h3 className="form-section-title">8. Review & Submit</h3>
      <div className="review-grid">
        <div>
          <strong>Permit Type:</strong> {permitTypeName || '-'}
        </div>
        <div>
          <strong>Status:</strong> {formData.status}
        </div>
        <div>
          <strong>Valid:</strong> {formData.validFrom || '-'} to {formData.validTo || '-'}
        </div>
        <div>
          <strong>Equipment:</strong> {machineName || '-'}
        </div>
        <div>
          <strong>Location:</strong> {formData.location || '-'}
        </div>
        <div>
          <strong>Area:</strong> {formData.area || '-'}
        </div>
      </div>
      <div className="form-group" style={{ marginTop: '1rem' }}>
        <label>Work Description</label>
        <div className="array-field-container">{formData.workDescription || '—'}</div>
      </div>
      <div className="form-group">
        <label>Hazards</label>
        <div className="array-field-container">
          {JSON.parse(formData.hazardsJson || '[]').length === 0 ? 'None' : JSON.parse(formData.hazardsJson || '[]').map((h, idx) => (
            <div key={idx}>
              <strong>{h.hazardType || 'Hazard'}</strong> — {h.hazardDescription} ({h.riskLevel})
            </div>
          ))}
        </div>
      </div>
      <div className="form-group">
        <label>Personnel</label>
        <div className="array-field-container">
          {JSON.parse(formData.personnelJson || '[]').length === 0 ? 'None' : JSON.parse(formData.personnelJson || '[]').map((p, idx) => (
            <div key={idx}>
              User #{p.userId} — {p.role}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WorkPermitStep8Review;

